import { handleActions } from 'redux-actions'
import * as c from './constants'

const init = {
  chat_markets: [],
  chat_restoreId: '',
  chat_initiated: false
}

export default handleActions({
  [c.GET_WIDGET_DATA]: (state, { payload }) => ({
    ...state,
    chat_markets: payload.activeMarkets || [],
    chat_restoreId: payload.restoreId || '',
    chat_initiated: true
  }),
  [c.SAVE_RESTORE_ID]: (state, { payload }) => ({
    ...state,
    chat_restoreId: payload.restoreId || ''
  })
}, init)
